import { render, staticRenderFns } from "./LogoAreaSearch.vue?vue&type=template&id=5f6b98ed&scoped=true"
import script from "./LogoAreaSearch.vue?vue&type=script&lang=js"
export * from "./LogoAreaSearch.vue?vue&type=script&lang=js"
import style0 from "./LogoAreaSearch.vue?vue&type=style&index=0&id=5f6b98ed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6b98ed",
  null
  
)

export default component.exports